if (!customElements.get('live-page-views')) {
  customElements.define('live-page-views', class LivePageViews extends HTMLElement {
    constructor() {
      super();

      this.minCount = this.dataset.minCount;
      this.contentWrapper = this.querySelector('.live-page-views--content');
      this.counter = this.querySelector('.live-page-views--counter');
      this.pageTitle = document.title;

      this.updateCounter()
      setInterval(this.updateCounter.bind(this), 30000);
    }

    updateCounter() {
      fetch('https://services.pw-solutions.de/sternglas-api/analytics/live-page-views?page_title=' + this.pageTitle)
        .then(res => res.ok && res.json())
        .then(res => {
          if (!res || res.numberOfPageViews === undefined) {
            throw 'missing value';
          }
          this.counter.innerHTML = res.numberOfPageViews
          if (+res.numberOfPageViews < this.minCount) {
            this.contentWrapper.classList.add('hidden')
          } else {
            this.contentWrapper.classList.remove('hidden')
          }
        })
    }
  });
}
